import { DEFAULT_VOTE_COOLDOWN_MINUTES } from 'projects/lib-ui/src/shared/constants/vote-cooldown.const';

export const resolveVoteCooldownMinutes = (
  minVoteIntervalMinutes?: number | null
): number => {
  if (
    minVoteIntervalMinutes === null ||
    minVoteIntervalMinutes === undefined ||
    minVoteIntervalMinutes !== minVoteIntervalMinutes ||
    minVoteIntervalMinutes <= 0
  ) {
    return DEFAULT_VOTE_COOLDOWN_MINUTES;
  }

  return minVoteIntervalMinutes;
};
